import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import useMedia from '@/hooks/useMedia'

// Components
import Image from '@/components/common/Image'
import PriceDisplayer from '@/components/shared/PriceDisplayer'
import Specs from '@/components/shared/Specs'
import Counter from '../../pages/Product/component/ValidProduct/component/Counter'

// Constants

// Types

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const SpecContent = (props: any) => {
  const {
    className,
    menu,
    filteredItems,
    searchKeyList,
    handleSearchKeyChange,
    setProductAmount,
    skuItemInfo,
    productInfo,
    isLive,
    isOutOfStock,
    productAmount,
    selectedCoupon,
    promotionPriceRangeData,
    isFullScreen,
    title,
  } = props

  const { t } = useTranslation()

  const { isMobile } = useMedia()

  return (
    <div className={cx('specContent', className)}>
      {title}
      {!!productInfo?.productName && (
        <div className={cx('specContent-info', { isFullScreen })}>
          <div className={cx('specContent-info-image')}>
            <Image
              alt='product-image'
              src={productInfo.images ? productInfo.images[0] : ''}
              width={70}
              height={70}
              style={{ objectFit: 'contain' }}
            />
          </div>

          <div className={cx('specContent-info-wrapper')}>
            <div className={cx('specContent-info-name')}>{productInfo?.productName}</div>
            <PriceDisplayer
              className={cx('specContent-info-price')}
              selectedCoupon={selectedCoupon}
              productInfo={productInfo}
              filteredItems={filteredItems}
              isLive={isLive}
              promotionPriceRangeData={promotionPriceRangeData}
              amount={productAmount}
            />
          </div>
        </div>
      )}
      <div className={cx('specContent-wrapper', { isFullScreen })}>
        <Specs
          menu={menu}
          filteredItems={filteredItems}
          searchKeyList={searchKeyList}
          skuItemInfo={skuItemInfo}
          handleSearchKeyChange={handleSearchKeyChange}
          isFullScreen={isFullScreen}
        />

        <div>
          {isMobile && <div className={cx('specContent-counter-text')}>{t('Common_Amount')}</div>}
          <Counter
            className={cx('specContent-counter')}
            onChange={setProductAmount}
            maximum={filteredItems.length === 1 ? filteredItems[0].stockQuantity : 0}
            hidden={filteredItems.length !== 1}
            maxInputWidth='60'
            showText={!isMobile}
            isOutOfStock={isOutOfStock}
            isFullScreen={isFullScreen}
          />
        </div>
      </div>
    </div>
  )
}

export default SpecContent
